import React from "react";
import {
  Button,
  Card,
  CardActions,
  CardContent,
  FormControlLabel,
  Paper,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const EnrolmentCard: React.FC<any> = ({ enrolment }) => {
  return (
    // <Card variant="outlined">
    //   <CardContent>
    <TableContainer component={Paper}>
      <Table aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Day</TableCell>
            <TableCell align="center">
              Morning <br /> (9:15-12:15)
            </TableCell>
            <TableCell align="center">
              Afternoon <br /> (12:15-15:15)
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell component="th" scope="row">
              Monday
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.monday.am} control={<Radio />} label="" />
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.monday.pm} control={<Radio />} label="" />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Tuesday
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.tuesday.am} control={<Radio />} label="" />
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.tuesday.pm} control={<Radio />} label="" />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Wednesday
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.wednesday.am} control={<Radio />} label="" />
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.wednesday.pm} control={<Radio />} label="" />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Thursday
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.thursday.am} control={<Radio />} label="" />
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.thursday.pm} control={<Radio />} label="" />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              Friday
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.friday.am} control={<Radio />} label="" />
            </TableCell>
            <TableCell align="right">
              <FormControlLabel checked={enrolment.friday.pm} control={<Radio />} label="" />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EnrolmentCard;
